import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { DiabetesFormsComponent } from '../../../components/diabetes-forms/diabetes-forms.component';
@Component({
  selector: 'app-aps',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DiabetesFormsComponent,
  ],
  templateUrl: './aps.component.html',
  styleUrl: './aps.component.scss',
})
export class ApsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
